export const hasUrlParam = (urlParam: string = '') => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.has(urlParam);
};
